module.exports = __webpack_public_path__ + "img/img48.44865fb7.svg";